import { createGlobalStyle } from 'styled-components/macro'
import { screen } from './mq'

export const GlobalStyle = createGlobalStyle`
* {
  box-sizing: border-box;
}

:root {
  --color-bg: #14130F;
  --color-text: #ffffff;
  --color-primary: #EFC29B;
}

html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  -webkit-tap-highlight-color: transparent;
  font-family: "Manrope", Arial, "Arial Unicode MS", Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

html {
  font-size: ${1000 / 16}%;
}

body {
  color: var(--color-text);
  font-size: 1.6rem;
  background-color: var(--color-bg);
}

.body_noscroll {
  @media(max-width: 1024px){
    overflow: hidden;
  }
}

#root {
  width: 100%;
  max-width: 1600px;
  margin: auto;
  padding: 0px 20px;
  height: 100%;
  @media(max-width: ${screen.xxl}){
    max-width: 1440px;
  }
  @media(max-width: ${screen.m}){
    padding: 0 8px;
  }
  @media(max-width: ${screen.xs}){
    padding: 0 12px;
  }
}
`
